import { CloseButton, Dialog, Portal, Text } from '@chakra-ui/react';

import { scrollbarStyles } from '@/theme/scrollbarStyles';
import { TCredentialCreate, TSystemCredential } from '@/types/credentials';
import { handleDropdownAwareClose } from '@/utils/dropdownInteraction';

import CreateCredentialForm from './CreateCredentialForm';

export interface CreateNewCredentialProps {
  isOpen: boolean;
  onClose: () => void;
  credential: TSystemCredential | null;
  onSubmit: (data: TCredentialCreate) => void;
  isLoading?: boolean;
}

const maxHeightWithPadding = 'calc(100vh - 24px)';

const CreateNewCredentialModal = ({ isOpen, onClose, onSubmit, isLoading = false, credential }: CreateNewCredentialProps) => {
  if (!isOpen || !credential) {
    return null;
  }

  return (
    <Dialog.Root
      placement="center"
      open={isOpen}
      onOpenChange={(e) => handleDropdownAwareClose(e.open, onClose)}
    >
      <Portal>
        <Dialog.Backdrop zIndex={1600} bg="blackAlpha.600" />
        <Dialog.Positioner zIndex={1600}>
          <Dialog.Content
            px={6}
            py={6}
            maxWidth="600px"
            maxHeight={maxHeightWithPadding}
            display="flex"
            overflow="hidden"
          >
            <Dialog.Header mb={6} display="flex" justifyContent="space-between" alignItems="center">
              <Text fontSize="22px" fontWeight={500} color="text.fg" lineHeight="28px" letterSpacing={0}>
                {credential.name}
              </Text>
              <CloseButton top={0} right={0} onClick={onClose} />
            </Dialog.Header>

            <Dialog.Body overflowY="auto" pr={1} css={scrollbarStyles}>
              <CreateCredentialForm
                credential={credential}
                onSubmit={onSubmit}
                onCancel={onClose}
                isLoading={isLoading}
                submitLabel="Create Credential"
              />
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default CreateNewCredentialModal;